
export const NAN = 'nan';
export const NA = 'N/A';

export const SIZE = {
    EXTRA_LARGE: 'xl',
    LARGE: 'lg',
    MEDIUM: 'md',
    SMALL: 'sm',
    EXTRA_SMALL: 'xs',
};

export const NOTIFICATION_STATUS = {
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error',
    INFO: 'info'
};
export const TOAST_NOTIFICATION_STATUS = {
    POSITIVE: 'positive',
    NEUTRAL: 'neutral',
    WARNING: 'warning'
};

export const CATEGORY = {
    STRUCTURAL: 'STRUCTURAL',
    TACTICAL: 'TACTICAL'
};

export const CHART_NAME = {
    CHART_STRUCTURAL: CATEGORY.STRUCTURAL,
    CHART_TACTICAL: CATEGORY.TACTICAL,
    CHART_NUMBER_OF_O_AND_D_CHANGED_FARE: 'Number of O&Ds Changed Fare',
    CHART_AVERAGE_FARE_CHANGE: 'AVERAGE FARE CHANGE',
    CHART_COMPETITIVE_CHANGE_FARE: 'CHART COMPETITIVE CHANGE FARE'
};

export const DASHBOARD_TOP_TABS_VALUE = {
    RECOMMENDATION: 'recommendation',
    COMPETITION: 'competition',
};

export const COMPETITION_STATUS_TABS = {
    COMPETITOR_CHANGES_FARES: 'Fares'
};

export const CRITERIA_MARKET_KEY = 'market';

export const PERCENTAGE_ABSOLUTE_TABS_VALUE = {
    PERCENTAGE: 'percentage',
    ABSOLUTE: 'absolute',
    RELATIVE: 'relative'
};

export const DEFAULT_DASHBOARD_HISTORY_DAYS = 30;
export const DASHBOARD_HISTORY_DAYS_CONFIG_KEY = 'FO_DASHBOARD_APPROVAL_DISPLAY_HISTORY';

export const IS_FARE_CHANGES_SUMMARY_FROM_ATHENA_KEY = 'IS_FARE_CHANGES_SUMMARY_FROM_ATHENA';

export const URL_SAVE_CRITERIA_CONTEXT_ID = 'fo-dashboard';
export const URL_CORE_PRICING_SAVE_CRITERIA_CONTEXT_ID = 'core-pricing';

export const COMMA = ',';

export const FO_HOST_CARRIER_KEY = 'FO_HOST_CARRIER';

export const FO_BENCHMARK_COMPONENTS = ['BASE FARE', 'YQ', 'YR', '6H', '6I', '6J', '6K', 'FUEL SURCHARGE', 'OTHER', 'VARIABLE', 'CAT12 SURCHARGE'];

export const CRITERIA_HEADER_DETAILS = [
    {
        KEY: 'org',
        VALUE: 'Origin'
    },
    {
        KEY: 'des',
        VALUE: 'Destination'
    },
    {
        KEY: 'mkt',
        VALUE: 'Market'
    },
    {
        KEY: 'mkt1',
        VALUE: 'Market'
    },
    {
        KEY: 'cxr',
        VALUE: 'Carrier'
    },
    {
        KEY: 'fbc',
        VALUE: 'Farebasis Code'
    },
    {
        KEY: 'tar',
        VALUE: 'Tariff Number'
    },
    {
        KEY: 'con',
        VALUE: 'Construction Method'
    },
    {
        KEY: 'vcc',
        VALUE: 'Vendor Change Code'
    },
    {
        KEY: 'gfs dt',
        VALUE: 'GFS Date'
    },
    {
        KEY: 'gfs',
        VALUE: 'GFS Filing Code'
    },
    {
        KEY: 'dow',
        VALUE: 'Day of the Week'
    },
    {
        KEY: 'min st',
        VALUE: 'Minimum Stay'
    },
    {
        KEY: 'rule tvl dt',
        VALUE: 'Rule Travel Dates'
    },
    {
        KEY: 'appl dt',
        VALUE: 'Applicable Dates'
    },
    {
        KEY: 'ft tvl dt',
        VALUE: 'Footnote Travel Dates'
    },
    {
        KEY: 'ft seas dt',
        VALUE: 'Footnote Season Dates'
    },
    {
        KEY: 'ft bo dt',
        VALUE: 'Footnote Blackout Dates'
    },
    {
        KEY: 'ft',
        VALUE: 'Footnote Code'
    },
    {
        KEY: 'rtg',
        VALUE: 'Routing'
    },
    {
        KEY: 'owrt',
        VALUE: 'OW/RT Indicator'
    },
    {
        KEY: 'cur',
        VALUE: 'Currency'
    },
    {
        KEY: 'amt',
        VALUE: 'Fare Amount'
    },
    {
        KEY: 'sur',
        VALUE: 'Surcharge'
    },
    {
        KEY: 'yq',
        VALUE: 'YQ'
    },
    {
        KEY: 'yr',
        VALUE: 'YR'
    },
    {
        KEY: 'tax',
        VALUE: 'Tax'
    },
    {
        KEY: 'ttl',
        VALUE: 'Total Fare'
    },
    {
        KEY: 'cab',
        VALUE: 'Cabin Code'
    },
    {
        KEY: 'rbd',
        VALUE: 'RBD'
    },
    {
        KEY: 'fst res',
        VALUE: 'First Reservation Date'
    },
    {
        KEY: 'lst res',
        VALUE: 'Last Reservation Date'
    },
    {
        KEY: 'fst tkt',
        VALUE: 'First Ticketing Date'
    },
    {
        KEY: 'lst tkt',
        VALUE: 'Last Ticketing Date'
    },
    {
        KEY: 'tvl st',
        VALUE: 'Commence From Travel Date'
    },
    {
        KEY: 'tvl end',
        VALUE: 'Commence To Travel Date'
    },
    {
        KEY: 'brd',
        VALUE: 'Brand'
    },
    {
        KEY: 'brd det',
        VALUE: 'Brand Details'
    },
    {
        KEY: 'eff dt',
        VALUE: 'Effective Date'
    },
    {
        KEY: 'disc dt',
        VALUE: 'Discontinue Date'
    },
    {
        KEY: 'rec dt',
        VALUE: 'Received Date'
    },
    {
        KEY: 'tvl cmplt',
        VALUE: 'Travel Complete'
    },
    {
        KEY: 'tvl dt',
        VALUE: 'Travel Date'
    },
    {
        KEY: 'con',
        VALUE: 'Construction Method'
    },
    {
        KEY: 'oc',
        VALUE: 'Origin Country Code'
    },
    {
        KEY: 'dc',
        VALUE: 'Destination Country Code'
    },
    {
        KEY: 'rule',
        VALUE: 'Rule Number'
    },
    {
        KEY: 'dow',
        VALUE: 'Day of the Week'
    },
    {
        KEY: 'seas dt',
        VALUE: 'Season Dates'
    },
    {
        KEY: 'ap',
        VALUE: 'Advanced Purchase'
    },
    {
        KEY: 'min st',
        VALUE: 'Minimum Stay'
    },
    {
        KEY: 'max st',
        VALUE: 'Maximum Stay'
    },
    {
        KEY: 'bo dt',
        VALUE: 'Blackout Dates'
    },
    // {
    //     KEY: 'min st num',
    //     VALUE: 'Minimum Stay Number'
    // },
    // {
    //     KEY: 'min st dow',
    //     VALUE: 'Minimum Stay Day of the Week'
    // },
    {
        KEY: 'ftc',
        VALUE: 'Fare Type Code'
    },
    {
        KEY: 'dow tc',
        VALUE: 'Day Of Week Type Code'
    },
    {
        KEY: 'seas tc',
        VALUE: 'Season Type Code'
    },
    {
        KEY: 'ptc',
        VALUE: 'Passenger Type Code'
    },
    {
        KEY: 'tkt dsg',
        VALUE: 'Ticket Designators'
    },
    {
        KEY: 'src',
        VALUE: 'Source'
    },
    {
        KEY: 'tier',
        VALUE: 'Market Tier'
    },
    {
        KEY: 'mkt grp',
        VALUE: 'Market Group'
    },
    {
        KEY: 'mkt typ',
        VALUE: 'Market Type'
    },
    {
        KEY: 'mkt ast',
        VALUE: 'Market Analyst'
    },
    {
        KEY: 'mkt cat',
        VALUE: 'Market Category'
    }
];
export const TOOL_BAR_BUTTONS = [
    {
        KEY: 'Fares'
    },
    {
        KEY: 'Footnotes'
    },
    {
        KEY: 'Rules'
    },
    {
        KEY: 'Other'
    }
];
export const OPERATOR_OPTIONS = [
    { label: '=', value: '=' },
    { label: '<>', value: '<>' },
    { label: '>', value: '>' },
    { label: '<', value: '<' },
    { label: '>=', value: '>=' },
    { label: '<=', value: '<=' }
];
export const SEARCH_CRITERIA_CONFIG = [
    {
        categeryName: 'Table',
        type: 'Checkbox',
        categoryDetails: [
            { key: 'Active', value: true },
            { key: 'Inactive', value: false },
            { key: 'Historical', value: false }
        ]
    },
    {
        categeryName: 'Products',
        type: 'Checkbox',
        categoryDetails: [
            { key: 'Spec', value: true },
            { key: 'Cons', value: false },
            { key: 'Web', value: false },
            { key: 'FBR', value: false }
        ]
    },
    {
        categeryName: 'Identifier',
        type: 'DropDownText',
        categoryDetails: [
            {
                keyCode: 'ORG',
                key:'origin',
                operator: '',
                values: ''
            },
            {
                keyCode: 'DES',
                key: 'destination',
                operator: '',
                values: ''
            },
            {
                keyCode: 'CXR',
                key:'carrier_code',
                operator: '',
                values: ''
            },
            {
                keyCode: 'FBC',
                key:'fareClassCode',
                operator: '',
                values: ''
            },
            {
                keyCode: 'TAR',
                key: 'tariffNumber',
                operator: '',
                values: ''
            },
            {
                keyCode: 'FT',
                key:'footnoteCode',
                operator: '',
                values: ''
            },
            {
                keyCode: 'RTG',
                key:'routingNumber',
                operator: '',
                values: ''
            },
            {
                keyCode: 'CON',
                key:'constructionMethod',
                operator: '',
                values: ''
            }
        ]
    },
    {
        categeryName: 'Fare Value',
        type: 'DropDownText',
        categoryDetails: [
            {
                keyCode: 'VCC',
                key:'actionCode',
                operator: '',
                values: ''
            },
            {
                keyCode: 'OWRT',
                key:'roundTripIndicator',
                operator: '',
                values: ''
            },
            {
                keyCode: 'CUR',
                key:'currencyCode',
                operator: '',
                values: ''
            },
            {
                keyCode: 'AMT',
                key:'fareAmount',
                operator: '',
                values: ''
            },
            {
                keyCode: 'SUR',
                key:'surchargeAmount',
                operator: '',
                values: ''
            },
            {
                keyCode: 'YQ',
                key:'yqAmount',
                operator: '',
                values: ''
            },
            {
                keyCode: 'YR',
                key:'yrAmount',
                operator: '',
                values: ''
            },
            {
                keyCode: 'TAX',
                key:'aggregatedTax',
                operator: '',
                values: ''
            },
            {
                keyCode: 'TTL',
                key:'totalFare',
                operator: '',
                values: ''
            },
            // {
            //     keyCode: 'CAB',
            //     key:'cabincode',
            //     operator: '',
            //     values: ''
            // },
        ]
    },
    {
        categeryName: 'Rule',
        type: 'DropDownText',
        categoryDetails: [
            {
                keyCode: 'RULE',
                key:'ruleNumber',
                operator: '',
                values: ''
            },
            {
                keyCode: 'DOW',
                key:'dow',
                operator: '',
                values: ''
            },
            {
                keyCode: 'SEAS DT',
                key:'ruleSeasonDates',
                operator: '',
                values: ''
            },
            {
                keyCode: 'AP',
                key:'advancePurchaseReservation',
                operator: '',
                values: ''
            },
            {
                keyCode: 'RULE TVL DT',
                key:'ruleTravelDates',
                operator: '',
                values: ''
            },
            {
                keyCode: 'APPL DT',
                key:'applicableDates',
                operator: '',
                values: ''
            },
            {
                keyCode: 'MIN ST',
                key:'minStay',
                operator: '',
                values: ''
            },
            {
                keyCode: 'MAX ST',
                key:'maxStay',
                operator: '',
                values: ''
            },
            {
                keyCode: 'BO DT',
                key:'ruleBlackOutDates',
                operator: '',
                values: ''
            }
        ]
    },
    {
        categeryName: 'Footnote',
        type: 'DropDownDate',
        categoryDetails: [
            {
                keyCode: 'FST RES',
                key:'footnoteReservationFromDate',
                operator: '',
                values: ''
            },
            {
                keyCode: 'LST RES',
                key:'footnoteReservationToDate',
                operator: '',
                values: ''
            },
            {
                keyCode: 'FST TKT',
                key:'footnoteTicketingFromDate',
                operator: '',
                values: ''
            },
            {
                keyCode: 'LST TKT',
                key:'footnoteTicketingToDate',
                operator: '',
                values: ''
            },
            {
                keyCode: 'TVL ST',
                key: 'footnoteOutboundTravelFromDate',
                operator: '',
                values: ''
            },
            {
                keyCode: 'TVL END',
                key:'footnoteOutboundTravelToDate',
                operator: '',
                values: ''
            },
            {
                keyCode: 'TVL CMPLT',
                key: 'footnoteOutboundTravelCompleteDate',
                operator: '',
                values: ''
            },
            {
                keyCode: 'FT TVL DT',
                key: 'footnoteTravelDates',
                operator: '',
                values: ''
            },
            {
                keyCode: 'FT SEAS DT',
                key: 'footnoteSeasonDates',
                operator: '',
                values: ''
            },
            {
                keyCode: 'FT BO DT',
                key: 'footnoteBlackOutDates',
                operator: '',
                values: ''
            }
        ]
    },
    {
        categeryName: 'Distribution',
        type: 'DropDownDate',
        categoryDetails: [
            {
                keyCode: 'EFF DT',
                key:'effectiveDate',
                operator: '',
                values: ''
            },
            {
                keyCode: 'DISC DT',
                key:'discontinueDate',
                operator: '',
                values: ''
            },
            {
                keyCode: 'REC DT',
                key:'transmissionDateTime',
                operator: '',
                values: ''
            },
            {
                keyCode: 'GFS',
                key:'gfsUniqueFillingCode',
                operator: '',
                values: ''
            },
            {
                keyCode: 'GFS DT',
                key:'gfsDate',
                operator: '',
                values: ''
            }
        ]
    },
    {
        categeryName: 'Fare Class',
        type: 'DropDownText',
        categoryDetails: [
            {
                keyCode: 'CAB',
                key:'cabinCode',
                operator: '',
                values: ''
            },
            {
                keyCode: 'RBD',
                key:'rbds',
                operator: '',
                values: ''
            },
            {
                keyCode: 'FTC',
                key:'fareTypeCode',
                operator: '',
                values: ''
            },
            {
                keyCode: 'DOW TC',
                key:'dayOfWeekTypeCode',
                operator: '',
                values: ''
            },
            {
                keyCode: 'SEAS TC',
                key: 'seasonTypeCode',
                operator: '',
                values: ''
            },
            {
                keyCode: 'PTC',
                key:'passengerTypes',
                operator: '',
                values: ''
            },
            {
                keyCode: 'TKT DSG',
                key: 'ticketDesignators',
                operator: '',
                values: ''
            }
        ]
    },
    {
        categeryName: 'Brand',
        type: 'DropDownText',
        categoryDetails: [
            {
                keyCode: 'BRD',
                key:'brand',
                operator: '',
                values: ''
            },
            {
                keyCode: 'BRD DET',
                key:'branddetails',
                operator: '',
                values: ''
            }
        ]
    },
    {
        categeryName: 'Market',
        type: 'DropDownText',
        categoryDetails: [
            {
                keyCode: 'OC',
                operator: '',
                values: ''
            },
            {
                keyCode: 'DC',
                operator: '',
                values: ''
            },
            {
                keyCode: 'MKT',
                operator: '',
                values: ''
            },
            {
                keyCode: 'SRC',
                operator: '',
                values: ''
            },
            {
                keyCode: 'TIER',
                operator: '',
                values: ''
            },
            {
                keyCode: 'MKT GRP',
                operator: '',
                values: ''
            },
            {
                keyCode: 'MKT TYP',
                operator: '',
                values: ''
            },
            {
                keyCode: 'MKT AST',
                operator: '',
                values: ''
            },
            {
                keyCode: 'MKT CAT',
                operator: '',
                values: ''
            }
        ]
    }
];
export const SEARCH_CRITERIA_FOOTER_CONFIG = [
    // {
    //     key: 'Link',
    //     value: 'Options'
    // },
    // {
    //     key: 'Link',
    //     value: 'Advanced'
    // },
    {
        key: 'Button',
        value: 'CLEAR',
        isSelect: false
    },
    {
        key: 'Button',
        value: 'STOP',
        isSelect: false
    },
    {
        key: 'Button',
        value: 'SEARCH',
        isSelect: false
    }
];
export const PRIMARY_TABLE = [
    { org: 'BBB', des: 'CCC', cxr: 'ZZ', fbc: 'LL106LGT', tar: 1, ft: '3O', rtg: '401' },
    { org: 'AAA', des: 'CCC', cxr: 'YY', fbc: 'LK106LGT', tar: 1, ft: '3V', rtg: '402' },
    { org: 'BBB', des: 'CCC', cxr: 'ZZ', fbc: 'TL287LGT', tar: 1, ft: '3O', rtg: '3195' },
    { org: 'AAA', des: 'DDD', cxr: 'YY', fbc: 'TLA46LGT', tar: 1, ft: 'AJ', rtg: '0' },
    { org: 'AAA', des: 'DDD', cxr: 'YY', fbc: 'TKA46LGT', tar: 1, ft: '5H', rtg: '432' },
    { org: 'AAA', des: 'DDD', cxr: 'YY', fbc: 'KLX87NCT', tar: 1, ft: '8Z', rtg: '401' },
    { org: 'AAA', des: 'DDD', cxr: 'ZZ', fbc: 'KKX87NCT', tar: 1, ft: '3O', rtg: '402' },
    { org: 'AAA', des: 'DDD', cxr: 'ZZ', fbc: 'KL181NCV', tar: 1, ft: '9K', rtg: '3195' },
    { org: 'AAA', des: 'CCC', cxr: 'ZZ', fbc: 'TLW46LGT', tar: 1, ft: 'GW', rtg: '0' },
    { org: 'AAA', des: 'CCC', cxr: 'YY', fbc: 'TKX77LGT', tar: 1, ft: '', rtg: '432' },
    { org: 'AAA', des: 'CCC', cxr: 'YY', fbc: 'TKW46LGT', tar: 1, ft: '9K', rtg: '401' },
    { org: 'BBB', des: 'CCC', cxr: 'YY', fbc: 'TLX77LGT', tar: 1, ft: '7A', rtg: '402' },
    { org: 'AAA', des: 'CCC', cxr: 'YY', fbc: 'TL181LGT', tar: 1, ft: '7A', rtg: '3195' },
    { org: 'AAA', des: 'DDD', cxr: 'ZZ', fbc: 'KL106NCV', tar: 1, ft: '9K', rtg: '0' },
    { org: 'AAA', des: 'DDD', cxr: 'ZZ', fbc: 'TL106LGT', tar: 1, ft: '7A', rtg: '432' },
    { org: 'AAA', des: 'DDD', cxr: 'ZZ', fbc: 'SL287LGT', tar: 1, ft: '7A', rtg: '401' },
    { org: 'AAA', des: 'DDD', cxr: 'YY', fbc: 'TKX87LGT', tar: 1, ft: '7A', rtg: '402' },
    { org: 'AAA', des: 'DDD', cxr: 'ZZ', fbc: 'TLX07LGT', tar: 1, ft: '7A', rtg: '3195' },
    { org: 'AAA', des: 'DDD', cxr: 'ZZ', fbc: 'TKX07LGT', tar: 1, ft: '3O', rtg: '0' },
    { org: 'AAA', des: 'DDD', cxr: 'ZZ', fbc: 'TK181LGT', tar: 1, ft: '7A', rtg: '432' },
    { org: 'AAA', des: 'CCC', cxr: 'YY', fbc: 'TK246LGT', tar: 1, ft: '3O', rtg: '401' },
    { org: 'AAA', des: 'CCC', cxr: 'ZZ', fbc: 'SL387LGT', tar: 1, ft: '3O', rtg: '600' },
    { org: 'AAA', des: 'CCC', cxr: 'ZZ', fbc: 'SK297LGT', tar: 1, ft: '3O', rtg: '3195' },
    { org: 'AAA', des: 'CCC', cxr: 'YY', fbc: 'SKX87LGT', tar: 1, ft: '5H', rtg: '0' },
    { org: 'AAA', des: 'CCC', cxr: 'YY', fbc: 'LKW87NCT', tar: 1, ft: '4G', rtg: '432' },
    { org: 'AAA', des: 'CCC', cxr: 'YY', fbc: 'LKX46NCT', tar: 1, ft: '5H', rtg: '401' },
    { org: 'AAA', des: 'CCC', cxr: 'YY', fbc: 'LLW87NCT', tar: 1, ft: '5H', rtg: '402' },
    { org: 'AAA', des: 'CCC', cxr: 'ZZ', fbc: 'LLX46NCT', tar: 1, ft: '8Z', rtg: '3195' },
    { org: 'AAA', des: 'DDD', cxr: 'ZZ', fbc: 'TLW77LGT', tar: 1, ft: '5H', rtg: '0' },
    { org: 'AAA', des: 'DDD', cxr: 'ZZ', fbc: 'TKW77LGT', tar: 1, ft: '5H', rtg: '432' },
    { org: 'AAA', des: 'DDD', cxr: 'YY', fbc: 'LL106NCV', tar: 1, ft: '3N', rtg: '401' },
    { org: 'AAA', des: 'DDD', cxr: 'ZZ', fbc: 'WL387LGT', tar: 1, ft: '3N', rtg: '402' },
    { org: 'AAA', des: 'DDD', cxr: 'YY', fbc: 'WK257LGT', tar: 1, ft: '9K', rtg: '3195' },
    { org: 'AAA', des: 'DDD', cxr: 'ZZ', fbc: 'WL226LGT', tar: 1, ft: '3N', rtg: '0' },
    { org: 'AAA', des: 'DDD', cxr: 'ZZ', fbc: 'TKW87LGT', tar: 1, ft: '7A', rtg: '432' },
    { org: 'AAA', des: 'DDD', cxr: 'ZZ', fbc: 'WKX87LGT', tar: 1, ft: '5H', rtg: '401' },
    { org: 'AAA', des: 'DDD', cxr: 'ZZ', fbc: 'SK106LGT', tar: 1, ft: '5H', rtg: '402' },
    { org: 'AAA', des: 'DDD', cxr: 'ZZ', fbc: 'LK106NCV', tar: 1, ft: '3V', rtg: '3195' },
    { org: 'AAA', des: 'DDD', cxr: 'ZZ', fbc: 'SL226LGT', tar: 1, ft: 'LL', rtg: '0' },
    { org: 'AAA', des: 'DDD', cxr: 'YY', fbc: 'TL287NCV', tar: 1, ft: 'DK', rtg: '432' },
    { org: 'AAA', des: 'DDD', cxr: 'ZZ', fbc: 'TKA46NCT', tar: 1, ft: '5H', rtg: '401' },
    { org: 'AAA', des: 'DDD', cxr: 'ZZ', fbc: 'TLA46NCT', tar: 1, ft: '3O', rtg: '402' },
    { org: 'AAA', des: 'DDD', cxr: 'ZZ', fbc: 'SKW07LGT', tar: 1, ft: '3N', rtg: '3195' },
    { org: 'BBB', des: 'CCC', cxr: 'YY', fbc: 'SLW07LGT', tar: 1, ft: '3N', rtg: '0' },
    { org: 'AAA', des: 'CCC', cxr: 'ZZ', fbc: 'SL186LGT', tar: 1, ft: '3N', rtg: '432' },
    { org: 'AAA', des: 'CCC', cxr: 'YY', fbc: 'WK287LGT', tar: 1, ft: '8Z', rtg: '401' },
    { org: 'AAA', des: 'CCC', cxr: 'YY', fbc: 'WK397LGT', tar: 1, ft: '3N', rtg: '402' },
    { org: 'AAA', des: 'CCC', cxr: 'ZZ', fbc: 'WKW87LGT', tar: 1, ft: '3N', rtg: '3195' },
    { org: 'AAA', des: 'CCC', cxr: 'YY', fbc: 'WL247LGT', tar: 1, ft: '9K', rtg: '0' },
    { org: 'AAA', des: 'CCC', cxr: 'ZZ', fbc: 'WKA46LGT', tar: 1, ft: '9K', rtg: '432' }

];
export const SECONDARY_FULL_TABLE = [
    {
        categoryTitle: 'fareValue',
        data: [
            { owrt: 2, cur: 'USD', amt: 215, sur: 0, yq: 300, yr: 100, tax: 98.57, ttl: 713.57, cab: 'Y', rbd: 'L' },
            { owrt: 2, cur: 'USD', amt: 233, sur: 0, yq: 300, yr: 100, tax: 98.57, ttl: 731.57, cab: 'Y', rbd: 'Q' },
            { owrt: 2, cur: 'USD', amt: 200, sur: 0, yq: 300, yr: 100, tax: 98.57, ttl: 738.69, cab: 'Y', rbd: 'K' },
            { owrt: 2, cur: 'USD', amt: 201, sur: 0, yq: 300, yr: 100, tax: 98.57, ttl: 739.69, cab: 'Y', rbd: 'K' },
            { owrt: 2, cur: 'USD', amt: 201, sur: 0, yq: 300, yr: 100, tax: 98.57, ttl: 740.57, cab: 'Y', rbd: 'K' },
            { owrt: 2, cur: 'USD', amt: 242, sur: 0, yq: 300, yr: 100, tax: 98.57, ttl: 749.57, cab: 'Y', rbd: 'K' },
            { owrt: 2, cur: 'USD', amt: 242, sur: 0, yq: 300, yr: 100, tax: 98.57, ttl: 770.57, cab: 'Y', rbd: 'S' },
            { owrt: 2, cur: 'USD', amt: 251, sur: 0, yq: 300, yr: 100, tax: 138.69, ttl: 770.57, cab: 'Y', rbd: 'S' },
            { owrt: 2, cur: 'USD', amt: 272, sur: 0, yq: 300, yr: 100, tax: 138.69, ttl: 770.57, cab: 'Y', rbd: 'L' },
            { owrt: 2, cur: 'USD', amt: 272, sur: 0, yq: 300, yr: 100, tax: 138.69, ttl: 779.57, cab: 'Y', rbd: 'W' },
            { owrt: 2, cur: 'USD', amt: 281, sur: 0, yq: 300, yr: 100, tax: 138.69, ttl: 783.57, cab: 'Y', rbd: 'L' },
            { owrt: 2, cur: 'USD', amt: 285, sur: 0, yq: 300, yr: 100, tax: 138.69, ttl: 783.57, cab: 'Y', rbd: 'Q' },
            { owrt: 2, cur: 'USD', amt: 250, sur: 0, yq: 300, yr: 100, tax: 138.69, ttl: 788.69, cab: 'Y', rbd: 'L' },
            { owrt: 2, cur: 'USD', amt: 300, sur: 0, yq: 600, yr: 100, tax: 138.69, ttl: 798.57, cab: 'Y', rbd: 'T' },
            { owrt: 2, cur: 'USD', amt: 300, sur: 0, yq: 600, yr: 100, tax: 138.69, ttl: 820.57, cab: 'Y', rbd: 'S' },
            { owrt: 2, cur: 'USD', amt: 342, sur: 600, yq: 600, yr: 100, tax: 352.47, ttl: 820.57, cab: 'Y', rbd: 'S' },
            { owrt: 2, cur: 'USD', amt: 398, sur: 600, yq: 600, yr: 100, tax: 138.69, ttl: 820.57, cab: 'Y', rbd: 'O' },
            { owrt: 2, cur: 'USD', amt: 398, sur: 600, yq: 600, yr: 100, tax: 352.47, ttl: 829.57, cab: 'Y', rbd: 'S' },
            { owrt: 2, cur: 'USD', amt: 372, sur: 600, yq: 600, yr: 100, tax: 138.69, ttl: 834.57, cab: 'Y', rbd: 'W' },
            { owrt: 2, cur: 'USD', amt: 385, sur: 600, yq: 300, yr: 100, tax: 138.69, ttl: 838.69, cab: 'Y', rbd: 'L' },
            { owrt: 2, cur: 'USD', amt: 350, sur: 600, yq: 300, yr: 100, tax: 138.69, ttl: 840.57, cab: 'Y', rbd: 'W' },
            { owrt: 2, cur: 'USD', amt: 350, sur: 600, yq: 300, yr: 100, tax: 138.69, ttl: 840.57, cab: 'Y', rbd: 'W' },
            { owrt: 2, cur: 'USD', amt: 400, sur: 600, yq: 300, yr: 100, tax: 352.47, ttl: 870.57, cab: 'Y', rbd: 'L' },
            { owrt: 2, cur: 'USD', amt: 350, sur: 600, yq: 300, yr: 100, tax: 98.57, ttl: 745.51, cab: 'Y', rbd: 'L' },
            { owrt: 2, cur: 'USD', amt: 403, sur: 600, yq: 300, yr: 100, tax: 98.57, ttl: 745.51, cab: 'Y', rbd: 'L' },
            { owrt: 2, cur: 'USD', amt: 410, sur: 600, yq: 300, yr: 100, tax: 98.57, ttl: 883.57, cab: 'Y', rbd: 'L' },
            { owrt: 2, cur: 'USD', amt: 370, sur: 600, yq: 300, yr: 100, tax: 98.57, ttl: 888.69, cab: 'Y', rbd: 'L' },
            { owrt: 2, cur: 'USD', amt: 371, sur: 600, yq: 300, yr: 100, tax: 98.57, ttl: 888.69, cab: 'Y', rbd: 'W' },
            { owrt: 2, cur: 'USD', amt: 422, sur: 600, yq: 300, yr: 100, tax: 98.57, ttl: 898.57, cab: 'Y', rbd: 'W' },
            { owrt: 2, cur: 'USD', amt: 428, sur: 600, yq: 300, yr: 100, tax: 98.57, ttl: 898.57, cab: 'Y', rbd: 'W' },
            { owrt: 2, cur: 'USD', amt: 281, sur: 600, yq: 600, yr: 100, tax: 98.57, ttl: 901.57, cab: 'Y', rbd: 'T' },
            { owrt: 2, cur: 'USD', amt: 285, sur: 640, yq: 600, yr: 100, tax: 98.57, ttl: 908.57, cab: 'Y', rbd: 'T' },
            { owrt: 2, cur: 'USD', amt: 300, sur: 640, yq: 600, yr: 100, tax: 98.57, ttl: 908.69, cab: 'Y', rbd: 'T' },
            { owrt: 2, cur: 'USD', amt: 450, sur: 640, yq: 600, yr: 100, tax: 98.57, ttl: 920.57, cab: 'Y', rbd: 'T' },
            { owrt: 2, cur: 'USD', amt: 402, sur: 640, yq: 600, yr: 100, tax: 98.57, ttl: 926.57, cab: 'Y', rbd: 'L' },
            { owrt: 2, cur: 'USD', amt: 402, sur: 640, yq: 600, yr: 100, tax: 98.57, ttl: 938.69, cab: 'Y', rbd: 'L' },
            { owrt: 2, cur: 'USD', amt: 402, sur: 640, yq: 600, yr: 100, tax: 98.57, ttl: 940.57, cab: 'Y', rbd: 'L' },
            { owrt: 2, cur: 'USD', amt: 395, sur: 640, yq: 600, yr: 100, tax: 98.57, ttl: 1002.47, cab: 'Y', rbd: 'L' },
            { owrt: 2, cur: 'USD', amt: 395, sur: 640, yq: 600, yr: 100, tax: 98.57, ttl: 800.29, cab: 'Y', rbd: 'L' },
            { owrt: 2, cur: 'USD', amt: 395, sur: 640, yq: 600, yr: 100, tax: 138.69, ttl: 1052.47, cab: 'Y', rbd: 'T' },
            { owrt: 2, cur: 'USD', amt: 298, sur: 640, yq: 600, yr: 100, tax: 138.69, ttl: 1170.57, cab: 'Y', rbd: 'T' },
            { owrt: 2, cur: 'USD', amt: 322, sur: 640, yq: 600, yr: 100, tax: 138.69, ttl: 800.29, cab: 'Y', rbd: 'T' },
            { owrt: 2, cur: 'USD', amt: 336, sur: 640, yq: 600, yr: 100, tax: 138.69, ttl: 800.29, cab: 'Y', rbd: 'T' },
            { owrt: 2, cur: 'USD', amt: 331, sur: 640, yq: 600, yr: 100, tax: 138.69, ttl: 800.29, cab: 'Y', rbd: 'T' },
            { owrt: 2, cur: 'USD', amt: 272, sur: 640, yq: 600, yr: 100, tax: 138.69, ttl: 800.29, cab: 'Y', rbd: 'T' },
            { owrt: 2, cur: 'USD', amt: 350, sur: 0, yq: 300, yr: 100, tax: 138.67, ttl: 800.29, cab: 'Y', rbd: 'T' },
            { owrt: 2, cur: 'USD', amt: 350, sur: 0, yq: 300, yr: 100, tax: 138.67, ttl: 800.29, cab: 'Y', rbd: 'K' },
            { owrt: 2, cur: 'USD', amt: 360, sur: 0, yq: 300, yr: 100, tax: 138.67, ttl: 1320.57, cab: 'Y', rbd: 'K' },
            { owrt: 2, cur: 'USD', amt: 215, sur: 0, yq: 300, yr: 100, tax: 138.67, ttl: 1389.57, cab: 'Y', rbd: 'K' },
            { owrt: 2, cur: 'USD', amt: 250, sur: 0, yq: 300, yr: 100, tax: 138.67, ttl: 1380.57, cab: 'Y', rbd: 'K' }


        ]
    },
    {
        categoryTitle: 'footnote',
        data: [
            { 'fst res': 'sfsdf', 'lst res': 'xczzxc', 'fst tkt': 'zxc', 'lst tkt': '', 'tvl st': '', 'tvl end': '', 'tvl cmplt': '', 'tvl dt': '' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '', 'tvl st': '', 'tvl end': '', 'tvl cmplt': '', 'tvl dt': '' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '', 'tvl st': '', 'tvl end': '', 'tvl cmplt': '', 'tvl dt': '' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '', 'tvl st': '', 'tvl end': '', 'tvl cmplt': '', 'tvl dt': '' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '', 'tvl st': '30JAN23', 'tvl end': '', 'tvl cmplt': '28JAN24', 'tvl dt': '30JAN23--28JAN24/10MAR24--23MAY24' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '', 'tvl st': '30JAN23', 'tvl end': '', 'tvl cmplt': '28JAN24', 'tvl dt': '30JAN23--28JAN24/10MAR24--23MAY24' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '', 'tvl st': '20JAN21', 'tvl end': '', 'tvl cmplt': '', 'tvl dt': '20JAN21--' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '', 'tvl st': '20JAN21', 'tvl end': '', 'tvl cmplt': '', 'tvl dt': '20JAN21--' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '', 'tvl st': '', 'tvl end': '', 'tvl cmplt': '', 'tvl dt': '' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '', 'tvl st': '30JAN23', 'tvl end': '', 'tvl cmplt': '28JAN24', 'tvl dt': '30JAN23--28JAN24/10MAR24--23MAY24' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '', 'tvl st': '20JAN21', 'tvl end': '', 'tvl cmplt': '', 'tvl dt': '20JAN21--' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '', 'tvl st': '20JAN21', 'tvl end': '', 'tvl cmplt': '', 'tvl dt': '20JAN21--' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '', 'tvl st': '20JAN21', 'tvl end': '', 'tvl cmplt': '', 'tvl dt': '20JAN21--' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '04JAN23', 'tvl st': '', 'tvl end': '', 'tvl cmplt': '31JAN24', 'tvl dt': '--31JAN23' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '04JAN23', 'tvl st': '', 'tvl end': '', 'tvl cmplt': '31JAN24', 'tvl dt': '--31JAN23' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '04JAN23', 'tvl st': '', 'tvl end': '', 'tvl cmplt': '31JAN24', 'tvl dt': '--31JAN23' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '', 'tvl st': '30JAN23', 'tvl end': '', 'tvl cmplt': '', 'tvl dt': '' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '', 'tvl st': '', 'tvl end': '', 'tvl cmplt': '', 'tvl dt': '' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '', 'tvl st': '20JAN21', 'tvl end': '', 'tvl cmplt': '', 'tvl dt': '20JAN21--' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '', 'tvl st': '20JAN21', 'tvl end': '', 'tvl cmplt': '', 'tvl dt': '20JAN21--' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '', 'tvl st': '20JAN21', 'tvl end': '', 'tvl cmplt': '', 'tvl dt': '20JAN21--' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '', 'tvl st': '20JAN21', 'tvl end': '', 'tvl cmplt': '', 'tvl dt': '20JAN21--' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '', 'tvl st': '', 'tvl end': '', 'tvl cmplt': '', 'tvl dt': '' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '', 'tvl st': '', 'tvl end': '', 'tvl cmplt': '', 'tvl dt': '' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '', 'tvl st': '', 'tvl end': '', 'tvl cmplt': '', 'tvl dt': '' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '', 'tvl st': '', 'tvl end': '', 'tvl cmplt': '', 'tvl dt': '' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '', 'tvl st': '', 'tvl end': '', 'tvl cmplt': '', 'tvl dt': '' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '04JAN23', 'tvl st': '31JAN23', 'tvl end': '', 'tvl cmplt': '', 'tvl dt': '--31JAN23' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '', 'tvl st': '', 'tvl end': '', 'tvl cmplt': '', 'tvl dt': '' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '', 'tvl st': '', 'tvl end': '', 'tvl cmplt': '', 'tvl dt': '' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '', 'tvl st': '28JAN23', 'tvl end': '', 'tvl cmplt': '31JAN23', 'tvl dt': '28JAN23--10JAN23' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '', 'tvl st': '', 'tvl end': '', 'tvl cmplt': '', 'tvl dt': '20JAN21--' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '', 'tvl st': '', 'tvl end': '', 'tvl cmplt': '', 'tvl dt': '20JAN21--' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '', 'tvl st': '20JAN21', 'tvl end': '', 'tvl cmplt': '', 'tvl dt': '20JAN21--' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '', 'tvl st': '', 'tvl end': '', 'tvl cmplt': '', 'tvl dt': '' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '', 'tvl st': '', 'tvl end': '', 'tvl cmplt': '', 'tvl dt': '' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '', 'tvl st': '', 'tvl end': '', 'tvl cmplt': '', 'tvl dt': '' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '', 'tvl st': '', 'tvl end': '', 'tvl cmplt': '', 'tvl dt': '29JAN20--' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '', 'tvl st': '', 'tvl end': '', 'tvl cmplt': '', 'tvl dt': '29JAN20--' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '', 'tvl st': '30JUN24', 'tvl end': '', 'tvl cmplt': '28JUN24', 'tvl dt': '30JUN24--28JUN24/10AUG24--23AUG24' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '04JAN23', 'tvl st': '31JAN23', 'tvl end': '', 'tvl cmplt': '31JAN23', 'tvl dt': '--31JAN23' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '04JAN23', 'tvl st': '31JAN23', 'tvl end': '', 'tvl cmplt': '31JAN23', 'tvl dt': '--31JAN23' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '04JAN23', 'tvl st': '31JAN23', 'tvl end': '', 'tvl cmplt': '31JAN23', 'tvl dt': '--31JAN23' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '', 'tvl st': '30APR24', 'tvl end': '', 'tvl cmplt': '28APR24', 'tvl dt': '30APR24--28APR24/10AUG24--23AUG24' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '', 'tvl st': '30APR24', 'tvl end': '', 'tvl cmplt': '28APR24', 'tvl dt': '30APR24--28APR24/10AUG24--23AUG24' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '', 'tvl st': '', 'tvl end': '', 'tvl cmplt': '', 'tvl dt': '28JAN21--' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '', 'tvl st': '', 'tvl end': '', 'tvl cmplt': '', 'tvl dt': '28JAN21--' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '', 'tvl st': '', 'tvl end': '', 'tvl cmplt': '', 'tvl dt': '28JAN21--' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '', 'tvl st': '30APR24', 'tvl end': '', 'tvl cmplt': '28APR24', 'tvl dt': '30APR24--28APR24/10AUG24--23AUG24' },
            { 'fst res': '', 'lst res': '', 'fst tkt': '', 'lst tkt': '', 'tvl st': '30APR24', 'tvl end': '', 'tvl cmplt': '28APR24', 'tvl dt': '30APR24--28APR24/10AUG24--23AUG24' }
        ]
    },
    {
        categoryTitle: 'rule',
        data: [
            { rule: 'E602', 'seas dt': '26JUN23-16SEP23/15OCT23-20DEC23/10JAN24-17JUN24', ap: 3, 'min st num': '', 'min st dow': 'SAT', 'max st': '6', 'bo dt': '' },
            { rule: 'E602', 'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24', ap: 9, 'min st num': '', 'min st dow': 'SAT', 'max st': '6', 'bo dt': '' },
            { rule: 'E602', 'seas dt': '26JUN23-16SEP23/15OCT23-20DEC23/10JAN24-17JUN24', ap: 9, 'min st num': '', 'min st dow': 'SAT', 'max st': '6', 'bo dt': '' },
            { rule: 'E602', 'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24', ap: 9, 'min st num': '', 'min st dow': 'SAT', 'max st': '6', 'bo dt': '' },
            { rule: 'E602', 'seas dt': '26JUN23-16SEP23/15OCT23-20DEC23/10JAN24-17JUN24', ap: 9, 'min st num': '', 'min st dow': 'SAT', 'max st': '6', 'bo dt': '' },
            { rule: 'E602', 'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24', ap: 9, 'min st num': '', 'min st dow': '', 'max st': '6', 'bo dt': '' },
            { rule: 'E602', 'seas dt': '26JUN23-16SEP23/15OCT23-20DEC23/10JAN24-17JUN24', ap: 9, 'min st num': '', 'min st dow': '', 'max st': '6', 'bo dt': '' },
            { rule: 'E602', 'seas dt': '26JUN23-16SEP23/15OCT23-20DEC23/10JAN24-17JUN24', ap: 22, 'min st num': '', 'min st dow': '', 'max st': '6', 'bo dt': '' },
            { rule: 'E602', 'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24', ap: 22, 'min st num': '', 'min st dow': '', 'max st': '6', 'bo dt': '' },
            { rule: 'E602', 'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24', ap: 22, 'min st num': '', 'min st dow': '', 'max st': '6', 'bo dt': '' },
            { rule: 'E700', 'seas dt': '26JUN23-16SEP23/15OCT23-20DEC23/10JAN24-17JUN24', ap: 54, 'min st num': '7', 'min st dow': '', 'max st': '6', 'bo dt': '' },
            { rule: 'E700', 'seas dt': '26JUN23-16SEP23/15OCT23-20DEC23/10JAN24-17JUN24', ap: 54, 'min st num': '7', 'min st dow': 'SAT', 'max st': '6', 'bo dt': '' },
            { rule: 'E700', 'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24', ap: 54, 'min st num': '7', 'min st dow': 'SAT', 'max st': '6', 'bo dt': '' },
            { rule: 'E700', 'seas dt': '26JUN23-16SEP23/15OCT23-20DEC23/10JAN24-17JUN24', ap: 54, 'min st num': '7', 'min st dow': 'SAT', 'max st': '6', 'bo dt': '' },
            { rule: 'E700', 'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24', ap: 54, 'min st num': '7', 'min st dow': 'SAT', 'max st': '6', 'bo dt': '' },
            { rule: 'E700', 'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24', ap: 90, 'min st num': '7', 'min st dow': 'SAT', 'max st': '6', 'bo dt': '' },
            { rule: 'E700', 'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24', ap: 90, 'min st num': '10', 'min st dow': '', 'max st': '6', 'bo dt': '' },
            { rule: 'E700', 'seas dt': '26JUN23-16SEP23/15OCT23-20DEC23/10JAN24-17JUN24', ap: 90, 'min st num': '10', 'min st dow': '', 'max st': '6', 'bo dt': '' },
            { rule: 'E700', 'seas dt': '26JUN23-16SEP23/15OCT23-20DEC23/10JAN24-17JUN24', ap: 90, 'min st num': '10', 'min st dow': '', 'max st': '6', 'bo dt': '' },
            { rule: 'E700', 'seas dt': '26JUN23-16SEP23/15OCT23-20DEC23/10JAN24-17JUN24', ap: 3, 'min st num': '10', 'min st dow': '', 'max st': '6', 'bo dt': '' },
            { rule: 'E700', 'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24', ap: 3, 'min st num': '10', 'min st dow': '', 'max st': '6', 'bo dt': '' },
            { rule: 'E700', 'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24', ap: 3, 'min st num': '10', 'min st dow': '', 'max st': '6', 'bo dt': '' },
            { rule: 'J513', 'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24', ap: 3, 'min st num': '10', 'min st dow': '', 'max st': '6', 'bo dt': '' },
            { rule: 'J513', 'seas dt': '26JUN23-16SEP23/15OCT23-20DEC23/10JAN24-17JUN24', ap: 81, 'min st num': '10', 'min st dow': '', 'max st': '6', 'bo dt': '' },
            { rule: 'J513', 'seas dt': '26JUN23-16SEP23/15OCT23-20DEC23/10JAN24-17JUN24', ap: 81, 'min st num': '10', 'min st dow': 'SAT', 'max st': '6', 'bo dt': '' },
            { rule: 'J513', 'seas dt': '26JUN23-16SEP23/15OCT23-20DEC23/10JAN24-17JUN24', ap: 81, 'min st num': '10', 'min st dow': 'SAT', 'max st': '6', 'bo dt': '' },
            { rule: 'J513', 'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24', ap: 81, 'min st num': '10', 'min st dow': 'SAT', 'max st': '6', 'bo dt': '' },
            { rule: 'J513', 'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24', ap: 81, 'min st num': '', 'min st dow': 'SAT', 'max st': '6', 'bo dt': '' },
            { rule: 'J513', 'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24', ap: 76, 'min st num': '', 'min st dow': 'SAT', 'max st': '6', 'bo dt': '' },
            { rule: 'J513', 'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24', ap: 76, 'min st num': '', 'min st dow': 'SAT', 'max st': '6', 'bo dt': '' },
            { rule: 'J513', 'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24', ap: 76, 'min st num': '', 'min st dow': 'SAT', 'max st': '6', 'bo dt': '' },
            { rule: 'J513', 'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24', ap: 98, 'min st num': '', 'min st dow': 'SAT', 'max st': '6', 'bo dt': '' },
            { rule: 'J505', 'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24', ap: 98, 'min st num': '', 'min st dow': 'SAT', 'max st': '6', 'bo dt': '' },
            { rule: 'J505', 'seas dt': '26JUN23-16SEP23/15OCT23-20DEC23/10JAN24-17JUN24', ap: 98, 'min st num': '', 'min st dow': '', 'max st': '6', 'bo dt': '' },
            { rule: 'J505', 'seas dt': '26JUN23-16SEP23/15OCT23-20DEC23/10JAN24-17JUN24', ap: 5, 'min st num': '', 'min st dow': '', 'max st': '6', 'bo dt': '' },
            { rule: 'J505', 'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24', ap: 5, 'min st num': '10', 'min st dow': '', 'max st': '6', 'bo dt': '' },
            { rule: 'J505', 'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24', ap: 5, 'min st num': '10', 'min st dow': '', 'max st': '6', 'bo dt': '' },
            { rule: 'J505', 'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24', ap: 5, 'min st num': '10', 'min st dow': '', 'max st': '6', 'bo dt': '' },
            { rule: 'J505', 'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24', ap: 43, 'min st num': '10', 'min st dow': '', 'max st': '6', 'bo dt': '' },
            { rule: 'J505', 'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24', ap: 43, 'min st num': '10', 'min st dow': '', 'max st': '6', 'bo dt': '' },
            { rule: 'J505', 'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24', ap: 43, 'min st num': '10', 'min st dow': '', 'max st': '6', 'bo dt': '' },
            { rule: 'J505', 'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24', ap: 4, 'min st num': '10', 'min st dow': '', 'max st': '6', 'bo dt': '' },
            { rule: 'J505', 'seas dt': '26JUN23-16SEP23/15OCT23-20DEC23/10JAN24-17JUN24', ap: 4, 'min st num': '10', 'min st dow': '', 'max st': '6', 'bo dt': '' },
            { rule: 'E602', 'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24', ap: 4, 'min st num': '7', 'min st dow': '', 'max st': '6', 'bo dt': '' },
            { rule: 'E602', 'seas dt': '26JUN23-16SEP23/15OCT23-20DEC23/10JAN24-17JUN24', ap: 4, 'min st num': '7', 'min st dow': '', 'max st': '6', 'bo dt': '' },
            { rule: 'E602', 'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24', ap: 67, 'min st num': '7', 'min st dow': 'SAT', 'max st': '6', 'bo dt': '' },
            { rule: 'E602', 'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24', ap: 67, 'min st num': '7', 'min st dow': 'SAT', 'max st': '6', 'bo dt': '' },
            { rule: 'E602', 'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24', ap: 67, 'min st num': '7', 'min st dow': 'SAT', 'max st': '6', 'bo dt': '' },
            { rule: 'E700', 'seas dt': '17SEP23-12OCT23/18JUN24-25JUN24', ap: 67, 'min st num': '7', 'min st dow': 'SAT', 'max st': '6', 'bo dt': '' },
            { rule: 'E700', 'seas dt': '26JUN23-16SEP23/15OCT23-20DEC23/10JAN24-17JUN24', ap: 67, 'min st num': '7', 'min st dow': 'SAT', 'max st': '6', 'bo dt': '' }

        ]
    },
    {
        categoryTitle: 'market',
        data: [
            { oc: 'US', dc: 'GR', mkt: 'BBBCCC' },
            { oc: 'US', dc: 'GR', mkt: 'BBBCCC' },
            { oc: 'US', dc: 'GR', mkt: 'BBBCCC' },
            { oc: 'US', dc: 'GR', mkt: 'BBBCCC' },
            { oc: 'US', dc: 'GR', mkt: 'BBBCCC' },
            { oc: 'US', dc: 'GR', mkt: 'BBBCCC' },
            { oc: 'US', dc: 'GR', mkt: 'BBBCCC' },
            { oc: 'US', dc: 'GR', mkt: 'BBBCCC' },
            { oc: 'US', dc: 'GR', mkt: 'BBBDDD' },
            { oc: 'US', dc: 'GR', mkt: 'BBBDDD' },
            { oc: 'US', dc: 'GB', mkt: 'BBBDDD' },
            { oc: 'US', dc: 'GB', mkt: 'BBBDDD' },
            { oc: 'US', dc: 'GB', mkt: 'BBBDDD' },
            { oc: 'US', dc: 'GB', mkt: 'BBBDDD' },
            { oc: 'US', dc: 'GB', mkt: 'BBBDDD' },
            { oc: 'US', dc: 'GB', mkt: 'BBBDDD' },
            { oc: 'US', dc: 'GB', mkt: 'BBBDDD' },
            { oc: 'US', dc: 'GB', mkt: 'BBBDDD' },
            { oc: 'US', dc: 'GB', mkt: 'BBBDDD' },
            { oc: 'US', dc: 'GB', mkt: 'BBBDDD' },
            { oc: 'US', dc: 'GB', mkt: 'BBBDDD' },
            { oc: 'US', dc: 'GB', mkt: 'BBBDDD' },
            { oc: 'US', dc: 'GB', mkt: 'BBBCCC' },
            { oc: 'US', dc: 'GR', mkt: 'BBBCCC' },
            { oc: 'US', dc: 'GR', mkt: 'BBBCCC' },
            { oc: 'US', dc: 'GR', mkt: 'BBBCCC' },
            { oc: 'US', dc: 'GR', mkt: 'BBBCCC' },
            { oc: 'US', dc: 'GR', mkt: 'BBBCCC' },
            { oc: 'US', dc: 'GR', mkt: 'BBBCCC' },
            { oc: 'US', dc: 'GR', mkt: 'BBBCCC' },
            { oc: 'US', dc: 'GR', mkt: 'BBBDDD' },
            { oc: 'US', dc: 'GR', mkt: 'BBBDDD' },
            { oc: 'US', dc: 'GR', mkt: 'BBBDDD' },
            { oc: 'US', dc: 'GR', mkt: 'BBBDDD' },
            { oc: 'US', dc: 'GB', mkt: 'BBBDDD' },
            { oc: 'US', dc: 'GB', mkt: 'BBBDDD' },
            { oc: 'US', dc: 'GB', mkt: 'BBBDDD' },
            { oc: 'US', dc: 'GB', mkt: 'BBBCCC' },
            { oc: 'US', dc: 'GB', mkt: 'BBBCCC' },
            { oc: 'US', dc: 'GB', mkt: 'BBBCCC' },
            { oc: 'US', dc: 'GB', mkt: 'BBBCCC' },
            { oc: 'US', dc: 'GB', mkt: 'BBBCCC' },
            { oc: 'US', dc: 'GB', mkt: 'BBBCCC' },
            { oc: 'US', dc: 'GR', mkt: 'BBBCCC' },
            { oc: 'US', dc: 'GR', mkt: 'BBBCCC' },
            { oc: 'US', dc: 'GR', mkt: 'BBBDDD' },
            { oc: 'US', dc: 'GR', mkt: 'BBBDDD' },
            { oc: 'US', dc: 'GR', mkt: 'BBBDDD' },
            { oc: 'US', dc: 'GR', mkt: 'BBBDDD' },
            { oc: 'US', dc: 'GR', mkt: 'BBBDDD' }
        ]
    },
    {
        categoryTitle: 'brand',
        data: [
            { brd: 'LIGHT', 'brd det': 'NO BAG' },
            { brd: 'LIGHT', 'brd det': 'NO BAG' },
            { brd: 'LIGHT', 'brd det': 'NO BAG' },
            { brd: 'LIGHT', 'brd det': 'NO BAG' },
            { brd: 'LIGHT', 'brd det': 'NO BAG' },
            { brd: 'LIGHT', 'brd det': 'NO BAG' },
            { brd: 'LIGHT', 'brd det': 'NO BAG' },
            { brd: 'LIGHT', 'brd det': 'NO BAG' },
            { brd: 'LIGHT', 'brd det': 'NO BAG' },
            { brd: 'LIGHT', 'brd det': 'NO BAG' },
            { brd: 'LIGHT', 'brd det': 'NO BAG' },
            { brd: 'FLEX', 'brd det': 'NO BAG' },
            { brd: 'FLEX', 'brd det': 'NO BAG' },
            { brd: 'FLEX', 'brd det': 'NO BAG' },
            { brd: 'FLEX', 'brd det': 'NO BAG' },
            { brd: 'FLEX', 'brd det': 'NO BAG' },
            { brd: 'FLEX', 'brd det': 'FREE BAG' },
            { brd: 'FLEX', 'brd det': 'FREE BAG' },
            { brd: 'FLEX', 'brd det': 'FREE BAG' },
            { brd: 'FLEX', 'brd det': 'FREE BAG' },
            { brd: 'FLEX', 'brd det': 'FREE BAG' },
            { brd: 'FLEX', 'brd det': 'FREE BAG' },
            { brd: 'FLEX', 'brd det': 'FREE BAG' },
            { brd: 'FLEX', 'brd det': 'FREE BAG' },
            { brd: 'FLEX', 'brd det': 'FREE BAG' },
            { brd: 'LIGHT', 'brd det': 'FREE BAG' },
            { brd: 'LIGHT', 'brd det': 'FREE BAG' },
            { brd: 'LIGHT', 'brd det': 'FREE BAG' },
            { brd: 'LIGHT', 'brd det': 'FREE BAG' },
            { brd: 'LIGHT', 'brd det': 'FREE BAG' },
            { brd: 'LIGHT', 'brd det': 'FREE BAG' },
            { brd: 'LIGHT', 'brd det': 'FREE BAG' },
            { brd: 'LIGHT', 'brd det': 'FREE BAG' },
            { brd: 'LIGHT', 'brd det': 'FREE BAG' },
            { brd: 'LIGHT', 'brd det': 'FREE BAG' },
            { brd: 'LIGHT', 'brd det': 'NO BAG' },
            { brd: 'LIGHT', 'brd det': 'NO BAG' },
            { brd: 'LIGHT', 'brd det': 'NO BAG' },
            { brd: 'LIGHT', 'brd det': 'NO BAG' },
            { brd: 'LIGHT', 'brd det': 'NO BAG' },
            { brd: 'LIGHT', 'brd det': 'NO BAG' },
            { brd: 'LIGHT', 'brd det': 'NO BAG' },
            { brd: 'FLEX', 'brd det': 'NO BAG' },
            { brd: 'FLEX', 'brd det': 'NO BAG' },
            { brd: 'FLEX', 'brd det': 'NO BAG' },
            { brd: 'FLEX', 'brd det': 'NO BAG' },
            { brd: 'FLEX', 'brd det': 'NO BAG' },
            { brd: 'FLEX', 'brd det': 'NO BAG' },
            { brd: 'FLEX', 'brd det': 'NO BAG' },
            { brd: 'FLEX', 'brd det': 'NO BAG' }

        ]
    },
    {
        categoryTitle: 'distribution',
        data: [
            { 'eff dt': '29JAN21', 'disc dt': '', 'rec dt': '28JAN21 1000' },
            { 'eff dt': '12JAN23', 'disc dt': '', 'rec dt': '11JAN23 1000' },
            { 'eff dt': '16JAN22', 'disc dt': '', 'rec dt': '15JAN22 1000' },
            { 'eff dt': '25JAN23', 'disc dt': '', 'rec dt': '24JAN23 1000' },
            { 'eff dt': '25JAN23', 'disc dt': '', 'rec dt': '24JAN23 1000' },
            { 'eff dt': '14JAN23', 'disc dt': '', 'rec dt': '13JAN23 1000' },
            { 'eff dt': '11JAN23', 'disc dt': '', 'rec dt': '10JAN23 1000' },
            { 'eff dt': '14JAN23', 'disc dt': '', 'rec dt': '13JAN23 1000' },
            { 'eff dt': '29JAN21', 'disc dt': '', 'rec dt': '28JAN21 1000' },
            { 'eff dt': '11JAN23', 'disc dt': '', 'rec dt': '10JAN23 1000' },
            { 'eff dt': '07JAN22', 'disc dt': '', 'rec dt': '06JAN22 1000' },
            { 'eff dt': '16JAN22', 'disc dt': '', 'rec dt': '15JAN22 1000' },
            { 'eff dt': '20JAN23', 'disc dt': '', 'rec dt': '19JAN23 1000' },
            { 'eff dt': '14JAN23', 'disc dt': '', 'rec dt': '13JAN23 1000' },
            { 'eff dt': '12JAN23', 'disc dt': '', 'rec dt': '11JAN23 1000' },
            { 'eff dt': '16JAN22', 'disc dt': '', 'rec dt': '15JAN22 1000' },
            { 'eff dt': '12JAN23', 'disc dt': '', 'rec dt': '11JAN23 1000' },
            { 'eff dt': '20JAN23', 'disc dt': '', 'rec dt': '19JAN23 1000' },
            { 'eff dt': '14JAN23', 'disc dt': '', 'rec dt': '13JAN23 1000' },
            { 'eff dt': '11JAN23', 'disc dt': '', 'rec dt': '10JAN23 1000' },
            { 'eff dt': '16JAN22', 'disc dt': '', 'rec dt': '15JAN22 1000' },
            { 'eff dt': '12JAN23', 'disc dt': '', 'rec dt': '11JAN23 1000' },
            { 'eff dt': '16JAN22', 'disc dt': '', 'rec dt': '15JAN22 1000' },
            { 'eff dt': '20JAN23', 'disc dt': '', 'rec dt': '19JAN23 1000' },
            { 'eff dt': '12JAN23', 'disc dt': '', 'rec dt': '11JAN23 1000' },
            { 'eff dt': '18JAN23', 'disc dt': '', 'rec dt': '17JAN23 1000' },
            { 'eff dt': '11JAN23', 'disc dt': '', 'rec dt': '10JAN23 1000' },
            { 'eff dt': '06JAN21', 'disc dt': '', 'rec dt': '05JAN21 1000' },
            { 'eff dt': '11JAN23', 'disc dt': '', 'rec dt': '10JAN23 1000' },
            { 'eff dt': '25JAN23', 'disc dt': '', 'rec dt': '24JAN23 1000' },
            { 'eff dt': '25JAN23', 'disc dt': '', 'rec dt': '24JAN23 1000' },
            { 'eff dt': '14JAN23', 'disc dt': '', 'rec dt': '13JAN23 1000' },
            { 'eff dt': '14JAN23', 'disc dt': '', 'rec dt': '13JAN23 1000' },
            { 'eff dt': '29JAN21', 'disc dt': '', 'rec dt': '28JAN21 1000' },
            { 'eff dt': '12JAN23', 'disc dt': '', 'rec dt': '11JAN23 1000' },
            { 'eff dt': '20JAN23', 'disc dt': '', 'rec dt': '19JAN23 1000' },
            { 'eff dt': '16JAN22', 'disc dt': '', 'rec dt': '15JAN22 1000' },
            { 'eff dt': '25JAN23', 'disc dt': '', 'rec dt': '24JAN23 1000' },
            { 'eff dt': '14JAN23', 'disc dt': '', 'rec dt': '13JAN23 1000' },
            { 'eff dt': '29JAN21', 'disc dt': '', 'rec dt': '28JAN21 1000' },
            { 'eff dt': '11JAN23', 'disc dt': '', 'rec dt': '10JAN23 1000' },
            { 'eff dt': '16JAN22', 'disc dt': '', 'rec dt': '15JAN22 1000' },
            { 'eff dt': '20JAN23', 'disc dt': '', 'rec dt': '19JAN23 1000' },
            { 'eff dt': '16JAN22', 'disc dt': '', 'rec dt': '15JAN22 1000' },
            { 'eff dt': '06JAN23', 'disc dt': '', 'rec dt': '05JAN23 1000' },
            { 'eff dt': '22JAN23', 'disc dt': '', 'rec dt': '21JAN23 1000' },
            { 'eff dt': '22JAN23', 'disc dt': '', 'rec dt': '21JAN23 1000' },
            { 'eff dt': '11JAN23', 'disc dt': '', 'rec dt': '10JAN23 1000' },
            { 'eff dt': '20JAN23', 'disc dt': '', 'rec dt': '19JAN23 1000' },
            { 'eff dt': '13JAN23', 'disc dt': '', 'rec dt': '12JAN23 1000' }
        ]
    }
];
export const MessageRole= {
    ALERT : "alert",
    REGION : "region",
    STATUS : "status"
}
export const MessageStatus ={
    SUCCESS : "success",
    WARNING : "warning",
    ERROR : "error",
    INFO : "info"
}
export const MessageType ={
    PAGE : "page",
    CONTAINER : "container"
}
export  const monthNames = ["JAN","FEB","MAR","APR","MAY","JUN","JUL","AUG","SEP","OCT","NOV","DEC"];
